// extracted by mini-css-extract-plugin
export default {"overlay":"ModalThanks_overlay__hWH5t","active":"ModalThanks_active__o-Gga","close":"ModalThanks_close__V1LP5","modal":"ModalThanks_modal__7BU45"};